import axios from 'axios'
import { Message } from 'element-ui'
import router from 'vue-router'
// 环境的切换
// if (process.env.NODE_ENV == 'development') {
//   // todo 开发环境
//   // axios.defaults.baseURL = 'https://admin.zxfast.com'
// } else if (process.env.NODE_ENV == 'debug') {
//   // todo 调试环境
//   // axios.defaults.baseURL = 'https://admin.zxfast.com'
// } else if (process.env.NODE_ENV == 'production') {
//   // todo 生产环境
//   axios.defaults.baseURL = 'https://agent.youfqb.com'
// }
axios.defaults.timeout = 5000
// axios.defaults.withCredentials = true
axios.defaults.headers.post['Content-Type'] = 'application/json;charsrt=utf-8'
const service = axios.create()
const token = sessionStorage.getItem('Apk-Jwt-Token')
// Request interceptors
service.interceptors.request.use(
  config => {
    const token = sessionStorage.getItem('Apk-Jwt-Token')
    // Add X-Access-Token header to every request, you can add other custom headers here
    if (token) {
      config.headers['Authorization'] = 'Bearer ' + token
    }
    // config.data = 
    return config
  },
  error => {
    // console.log(error)
    Promise.reject(error)
  }
)

// Response interceptors
service.interceptors.response.use(
  response => {
    // code == OK: 成功
    const res = response.data
    if (res.status !== 200) {
      // 全局错误提示
      Message({
        message: res.message || 'Error',
        type: 'error',
        duration: 5 * 1000
      })
      // if (
      //   res.code === 'PERMISSION_DENIED'
      // ) {
      //   MessageBox.confirm(
      //     '你已被登出，可以取消继续留在该页面，或者重新登录',
      //     '确定登出',
      //     {
      //       confirmButtonText: '重新登录',
      //       cancelButtonText: '取消',
      //       type: 'warning'
      //     }
      //   ).then(() => {
      //     // UserModule.ResetToken()
      //     location.reload() // To prevent bugs from vue-router
      //   })
      // }
      return Promise.reject(res)
    } else {
      return response.data
    }
  },
  error => {
    // console.log(error.response)
    let status = error.response.status
    if (status === 401) {
      if (window.location.pathname !== '/login') {
        sessionStorage.removeItem('Apk-Jwt-Token')
        // location.reload()
      }
    }
    Message({
      message: error.response.data.message,
      type: 'error',
      duration: 5 * 1000
    })
    return Promise.reject(error.response)
  }
)
export default service
